const Target: React.FC<React.SVGProps<SVGSVGElement>> = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={props.className ?? ''}>
      <g clipPath="url(#clip0_5851_12308)">
        <path
          d="M7.33342 0.666504V2.0389C4.53723 2.34308 2.34332 4.53698 2.03914 7.33317H0.666748V8.6665H2.03914C2.34332 11.4627 4.53723 13.6566 7.33342 13.9608V15.3332H8.66675V13.9608C11.4629 13.6566 13.6568 11.4627 13.961 8.6665H15.3334V7.33317H13.961C13.6568 4.53698 11.4629 2.34308 8.66675 2.0389V0.666504H7.33342ZM8.00008 3.33317C10.6001 3.33317 12.6667 5.39984 12.6667 7.99984C12.6667 10.5998 10.6001 12.6665 8.00008 12.6665C5.40008 12.6665 3.33341 10.5998 3.33341 7.99984C3.33341 5.39984 5.40008 3.33317 8.00008 3.33317ZM8.00008 5.99984C7.46965 5.99984 6.96094 6.21055 6.58587 6.58562C6.21079 6.9607 6.00008 7.4694 6.00008 7.99984C6.00008 8.53027 6.21079 9.03898 6.58587 9.41405C6.96094 9.78912 7.46965 9.99984 8.00008 9.99984C8.53051 9.99984 9.03922 9.78912 9.4143 9.41405C9.78937 9.03898 10.0001 8.53027 10.0001 7.99984C10.0001 7.4694 9.78937 6.9607 9.4143 6.58562C9.03922 6.21055 8.53051 5.99984 8.00008 5.99984Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_5851_12308">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Target;
